import { loadApplicationIntake } from "@/features/applications";

export const applicationFlowRoute = {
    loader: loadApplicationIntake,
    head: () => ({ meta: [{ title: "Application | Wags" }] }),
};
